<div class="journal-line-detail-container">
  <div class="detail-header ml-2">
    <div class="header-left">
      <h4>{{ equipmentNum }}</h4>
      <p>
        {{ lineStatus }}
      </p>
    </div>
    <div>
      <button
        nbButton
        status="success"
        size="small"
        (click)="submit()"
        [disabled]="!canSubmit()"
        >
        <nb-icon icon="checkmark-outline"></nb-icon>
        SUBMIT
      </button>
    </div>
  </div>

  <div class="detail-content mt-2">
    <!-- Left Column - Equipment Information -->
    <div class="left-column">
      <nb-card class="sv-detail-card">
        <nb-card-header>
          <div class="d-flex">
            Equipment Information
            <span style="flex-grow: 1"></span>
            @if (!this.lineData?.equipment?.issueReported) {
              <div class="report-issue-section mb-1">
                <span style="flex-grow: 1"></span>
                <button
                  nbButton
                  ghost
                  status="primary"
                  size="small"
                  (click)="openReportIssueDialog()"
                  >
                  <nb-icon icon="alert-circle-outline"></nb-icon>
                  Report Issue
                </button>
              </div>
            }
          </div>

          @if (this.lineData?.equipment?.issueReported) {
            <nb-alert status="warning" class="eq-alert-container mt-2">
              <div class="eq-alert-header">
                <div class="eq-alert-title">
                  <nb-icon icon="alert-circle"></nb-icon>
                  <strong>Equipment Issue</strong>
                </div>
                <div class="eq-alert-actions">
                  <button
                    (click)="openReportIssueDialog()"
                    nbButton
                    size="tiny"
                    status="control"
                    >
                    <nb-icon icon="edit-outline"></nb-icon>
                    Edit
                  </button>
                </div>
              </div>
              @if (this.lineData?.equipment?.issueReported) {
                <div class="eq-alert-tags">
                  @for (
                    issue of this.lineData?.equipment?.issueReported?.split(
                    ','
                    )
                    ; track
                    issue) {
                    <nb-tag
                      [text]="issue"
                      size="small"
                      class="mr-1"
                      removable
                      (remove)="updateIssueReported($event)"
                    ></nb-tag>
                  }
                </div>
              }
              @if (this.lineData?.equipment?.issueNotes) {
                <p class="mt-1 issueNotes">
                  <b>{{ 'Notes: ' + this.lineData?.equipment?.issueNotes }} </b>
                </p>
              }
            </nb-alert>
          }
        </nb-card-header>
        <nb-card-body>
          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-equipment-num" class="label">Equipment No.</label>
            </div>
            <div class="col">
              <nb-form-field>
                <input
                  nbInput
                  fullWidth
                  fieldSize="small"
                  [value]="equipmentNum"
                  readonly
                  id="line-equipment-num"
                  />
                <button
                  nbSuffix
                  nbButton
                  ghost
                  size="small"
                  (click)="openEquipmentDetail()"
                  >
                  <nb-icon icon="external-link-outline" pack="eva"> </nb-icon>
                </button>
              </nb-form-field>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-serial" class="label">Serial</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="serial"
                readonly
                id="line-serial"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-fleet-code" class="label">Fleet Code</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="fleetCode"
                readonly
                id="line-fleet-code"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-model" class="label">Model</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="model"
                readonly
                id="line-model"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-make" class="label">Make</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="make"
                readonly
                id="line-make"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-parent-object" class="label">Parent Object</label>
            </div>
            <div class="col">
              <nb-form-field>
                <input
                  nbInput
                  fullWidth
                  fieldSize="small"
                  [value]="parentObjectNum"
                  readonly
                  id="line-parent-object"
                  />
                <button
                  nbSuffix
                  nbButton
                  ghost
                  size="small"
                  (click)="openParentEquipmentDetail()"
                  >
                  <nb-icon icon="external-link-outline" pack="eva"> </nb-icon>
                </button>
              </nb-form-field>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-fleet-type" class="label">Fleet Type</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="fleetType"
                readonly
                id="line-fleet-type"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-equipment-status" class="label">Equipment Status</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="equipmentStatus"
                readonly
                id="line-equipment-status"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-rental-status" class="label">Rental Status</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="rentalStatus"
                readonly
                id="line-rental-status"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-rental-contract" class="label">Rental Contract No.</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="rentalContractNum"
                readonly
                id="line-rental-contract"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-branch" class="label">Branch</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="branch"
                readonly
                id="line-branch"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-book-value" class="label">Book Value</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="bookValue"
                readonly
                id="line-book-value"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-description" class="label">Description</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="description"
                readonly
                id="line-description"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-description-2" class="label">Description 2</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="description2"
                readonly
                id="line-description-2"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-current-location" class="label">Current Location</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="equipmentLocation"
                readonly
                id="line-current-location"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-current-station" class="label">Current Station</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="equipmentStation"
                readonly
                id="line-current-station"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-customer-num" class="label">Customer #</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="customerNum"
                readonly
                id="line-customer-num"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-customer-name" class="label">Customer Name</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="customerName"
                readonly
                id="line-customer-name"
                />
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>

    <!-- Right Column - Inventory Detail & Attachments -->
    <div class="right-column">
      <!-- Inventory Detail Card -->
      <nb-card class="sv-detail-card">
        <nb-card-header>Inventory Detail</nb-card-header>
        <nb-card-body>
          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-status" class="label">Status</label>
            </div>
            <div class="col">
              @if (isStatusDisabled) {
                <input
                  nbInput
                  fullWidth
                  fieldSize="small"
                  [value]="selectedStatus"
                  readonly
                  id="line-status"
                  />
              } @else {
                <nb-select
                  fullWidth
                  size="small"
                  status="primary"
                  placeholder="Select Status"
                  [(selected)]="selectedStatus"
                  (selectedChange)="onStatusChange($event)"
                  class="editable-input"
                  aria-label="Status"
                  >
                  @for (option of statusOptions; track option) {
                    <nb-option
                      [value]="option.value"
                      >
                      {{ option.label }}
                    </nb-option>
                  }
                </nb-select>
              }
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-journal-location" class="label">Journal Location</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="expectedLocation"
                readonly
                id="line-journal-location"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-journal-station" class="label">Journal Station</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="expectedStation"
                readonly
                id="line-journal-station"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-found-location" class="label">Found Location</label>
            </div>
            <div class="col">
              <input
                nbInput
                fullWidth
                fieldSize="small"
                [value]="actualLocation"
                readonly
                id="line-found-location"
                />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label class="label"
                >Found Station
                @if (isFoundStationRequired) {
                  <span class="text-danger"
                    >*</span
                    >
                  }
                </label>
              </div>
              <div class="col">
                <!-- <input nbInput fullWidth fieldSize="small" [value]="actualStation" readonly disabled /> -->
                <stack-mono-dynamic-input
                  objectType="Station"
                  (objectChange)="onActualStationChange($event)"
                  displayField="station"
                  searchFields="station"
                  [placeholder]="'Enter Actual Station'"
                  [searchFields]="['station']"
                  [selectedObject]="this.selectedActualStation"
                  [fieldSize]="'small'"
                  [required]="isFoundStationRequired"
                ></stack-mono-dynamic-input>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 leaders">
                <label class="label"
                  >Disposition
                  @if (isDispositionRequired) {
                    <span class="text-danger">*</span>
                  }
                </label>
              </div>
              <div class="col">
                <div class="d-flex align-items-center">
                  <nb-select
                  [status]="
                    isDispositionRequired && !selectedDisposition
                      ? 'danger'
                      : 'primary'
                  "
                    fullWidth
                    size="small"
                    placeholder="Select Disposition"
                    [(selected)]="selectedDisposition"
                    (selectedChange)="onDispositionChange($event)"
                    [disabled]="isDispositionDisabled"
                    style="flex: 1"
                    aria-label="Disposition"
                    >
                    <nb-option [value]="null"> &nbsp;</nb-option>
                    @for (option of dispositionOptions; track option) {
                      <nb-option
                        [value]="option.value"
                        >
                        {{ option.label }}
                      </nb-option>
                    }
                  </nb-select>
                  <!-- <button
                  *ngIf="canClearDisposition"
                  nbButton
                  ghost
                  size="small"
                  status="medium"
                  (click)="clearDisposition()"
                  nbTooltip="Clear disposition"
                  class="ml-1"
                  >
                  <nb-icon icon="close-outline" pack="eva"></nb-icon>
                </button> -->
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 leaders">
              <label for="line-notes" class="label">Notes</label>
            </div>
            <div class="col">
              <textarea
                nbInput
                status="primary"
                fullWidth
                fieldSize="small"
                [(ngModel)]="notes"
                placeholder="Enter notes..."
                rows="3"
                id="line-notes"
              ></textarea>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Document Attachments Card -->

      @if (lineData?.id) {
        <next-attachment
          [refId]="lineData.id"
          object="EquipmentCountingJournalLine"
          [documentTypes]="documentTypes"
          [showToolbar]="true"
          [allowDelete]="true"
          (hasRequiredFiles)="onHasRequiredFilesChange($event)"
        ></next-attachment>
      }
    </div>
  </div>
</div>
